import { BankAccountDto } from "../../../Types/Api/DTO/BankAccountDto";

export const allBanks = (state: BankAccountDto[] = [], action: any) => {
  switch (action.type) {
    case "ALL_BANKS":
      return action.payload;
    default:
      return state;
  }
};
